import { useEntityLinkVerdict } from "~/ai-chat/data-source/use-entity-link-verdict";
import { ChatEntityChip, type ChatEntityChipProps } from "~/ai-chat/ui/chat-entity-chip";
import { toResourceNavigationPath } from "~/routes";

type ChatVerifiedEntityChipProps = Omit<ChatEntityChipProps, "navigationPath">;

// The chip the transcript renders for an assistant-emitted link: the LLM can hallucinate an
// id, so the link stays inert until the backend confirms the object exists.
export function ChatVerifiedEntityChip(props: ChatVerifiedEntityChipProps) {
  const verdict = useEntityLinkVerdict(props.link);
  const navigationPath = toResourceNavigationPath(props.link.path);
  return <ChatEntityChip {...props} navigationPath={navigationPath} verdict={verdict} />;
}
